import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=f1f6a7ee"
import script from "./PaymentDescription.vue?vue&type=script&lang=js"
export * from "./PaymentDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports